import { useState } from 'react';
export const useMutation = (mutationFn, options = {}) => {
    const [state, setState] = useState('UNINITIALIZED');
    const [recentMutation, setRecentMutation] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const reset = () => {
        setState('UNINITIALIZED');
        setRecentMutation(false);
        setError(null);
        setData(null);
    };
    const mutate = async (...args) => {
        setState('LOADING');
        setError(null);
        try {
            const data = await mutationFn(...args);
            setData(data);
            setState('SUCCESS');
            if (options.onSuccess) {
                options.onSuccess(data, ...args);
            }
            setRecentMutation(true);
            setTimeout(() => {
                setRecentMutation(false);
            }, 2000);
        }
        catch (err) {
            setError(err);
            setState('ERROR');
            if (options.onError) {
                options.onError(err, ...args);
            }
        }
        finally {
            if (options.onSettled) {
                options.onSettled(...args);
            }
        }
    };
    return {
        isLoading: state === 'LOADING',
        isSuccess: state === 'SUCCESS',
        isInitialized: state !== 'UNINITIALIZED',
        isError: state === 'ERROR',
        status: state,
        recentMutation,
        data,
        error,
        reset,
        mutate,
    };
};
//# sourceMappingURL=hooks.js.map